import { Card } from "@mui/material";
import { Divider } from "@monolith-forensics/monolith-ui";
import React, { useEffect, useState } from "react";
import { getEvidenceReportMetrics } from "../../../../api";
import convertToBytes from "@/utils/convertToBytes";
import convertBytesToSize from "@/utils/convertBytesToSize";

const EvidenceReportMetrics = ({ reportInfo }) => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    getEvidenceReportMetrics({
      ...reportInfo.report_parameters,
      dimension: "stats",
    }).then((result) => {
      setMetrics(result);
    });
  }, []);

  return (
    <Card
      style={{
        padding: "20px",
        textAlign: "left",
        flexGrow: 1,
        flexBasis: "10px",
      }}
    >
      <div>
        <div
          style={{
            fontSize: "larger",
          }}
        >
          Metrics
        </div>
        <Divider style={{ margin: "16px 0" }} />
        <div
          style={{
            minWidth: "300px",
          }}
        >
          {metrics && (
            <>
              {typeof metrics !== "undefined" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "5px",
                    }}
                  >
                    <div>Evidence Items:</div>
                    <div>{metrics?.evidence_count || 0}</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "5px",
                    }}
                  >
                    <div>Evidence Capacity:</div>
                    <div>
                      {metrics.total_capacity_gb
                        ? convertBytesToSize(
                            convertToBytes(metrics.total_capacity_gb, "GB")
                          )
                        : "0.00 GB"}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "5px",
                    }}
                  >
                    <div>Acquired Data:</div>
                    <div>
                      {metrics.acquired_data_gb
                        ? convertBytesToSize(
                            convertToBytes(metrics.acquired_data_gb, "GB")
                          )
                        : "0.00 GB"}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "5px",
                    }}
                  >
                    <div>Acquisition Rate:</div>
                    <div>
                      {metrics.avg_acq_rate
                        ? metrics.avg_acq_rate.toFixed(2) + " Days"
                        : "N/A"}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export default EvidenceReportMetrics;
